import { render, staticRenderFns } from "./selectable-card.vue?vue&type=template&id=ea2d6e68"
import script from "./selectable-card.vue?vue&type=script&lang=js"
export * from "./selectable-card.vue?vue&type=script&lang=js"
import style0 from "./selectable-card.vue?vue&type=style&index=0&id=ea2d6e68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports